import { PayloadAction } from '@reduxjs/toolkit'
import specialityOptionModel, { CreateSpecialityOptionDto, SpecialityOption, UpdateSpecialityOptionDto } from '@/core/models/speciality-option.model'
import { SearchRequest } from '@/core/types/request'
import { call, put, takeLatest } from 'redux-saga/effects'

import {
  createSpecialityOption as createSpecialityOptionAction,
  createSpecialityOptionSuccess as createSpecialityOptionSuccessAction,
  createSpecialityOptionFailure as createSpecialityOptionFailureAction,
  deleteSpecialityOption as deleteSpecialityOptionAction,
  deleteSpecialityOptionSuccess as deleteSpecialityOptionSuccessAction,
  deleteSpecialityOptionFailure as deleteSpecialityOptionFailureAction,
  getSpecialityOptions as getSpecialityOptionsAction,
  getSpecialityOptionsSuccess as getSpecialityOptionsSuccessAction,
  getSpecialityOptionsFailure as getSpecialityOptionsFailureAction,
  updateSpecialityOption as updateSpecialityOptionAction,
  updateSpecialityOptionSuccess as updateSpecialityOptionSuccessAction,
  updateSpecialityOptionFailure as updateSpecialityOptionFailureAction,
} from '@/redux/reducers/speciality-option.reducer'

import { handleError } from '@/utils/errors'

function* createSpecialityOption(action: PayloadAction<CreateSpecialityOptionDto>) {
  try {
    const specialityOption: SpecialityOption = yield call(specialityOptionModel.createSpecialityOption, action.payload)
    yield put(createSpecialityOptionSuccessAction(specialityOption))
  } catch (e) {
    yield put(createSpecialityOptionFailureAction(handleError(e)))
  }
}

function* deleteSpecialityOption(action: PayloadAction<string>) {
  try {
    yield call(specialityOptionModel.deleteSpecialityOption, action.payload)
    yield put(deleteSpecialityOptionSuccessAction(action.payload))
  } catch (e) {
    yield put(deleteSpecialityOptionFailureAction(handleError(e)))
  }
}

function* getSpecialityOptions(action: PayloadAction<SearchRequest | undefined>) {
  try {
    const specialityOptions: SpecialityOption[] = yield call(specialityOptionModel.getSpecialityOptions, action.payload)
    yield put(getSpecialityOptionsSuccessAction(specialityOptions))
  } catch (e) {
    yield put(getSpecialityOptionsFailureAction(handleError(e)))
  }
}

function* updateSpecialityOption(action: PayloadAction<{ specialityOptionId: string; updateSpecialityOptionDto: UpdateSpecialityOptionDto }>) {
  try {
    const { specialityOptionId, updateSpecialityOptionDto } = action.payload
    const specialityOption: SpecialityOption = yield call(specialityOptionModel.updateSpecialityOption, specialityOptionId, updateSpecialityOptionDto)
    yield put(updateSpecialityOptionSuccessAction(specialityOption))
  } catch (e) {
    yield put(updateSpecialityOptionFailureAction(handleError(e)))
  }
}

const watchSpecialityOptionSagas = [
  takeLatest(createSpecialityOptionAction.type, createSpecialityOption),
  takeLatest(deleteSpecialityOptionAction.type, deleteSpecialityOption),
  takeLatest(getSpecialityOptionsAction.type, getSpecialityOptions),
  takeLatest(updateSpecialityOptionAction.type, updateSpecialityOption),
]

export default watchSpecialityOptionSagas
